module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgment"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Inmemory"
    }
  }, [_vm._v("“In Memory”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("A Startling Discovery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming of Age in the Palm Beaches")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("These Things Happen")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Investigation to Nowhere")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He Strangled Donald Trump’s Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letter from Inside the Jail")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guilty in Hindsight")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Afterglow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“After Glow”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0